<template>
  <div class="collector-page">
    <Button type="primary" icon="plus-round" v-if="permissions === true" @click="edit(-1)">{{$t('device.group.New_group')}}</Button>
    <Button type="primary" icon="plus-round" v-if="permissions !== true" @click="edit(-1)" disabled>{{$t('device.group.New_group')}}</Button>
    <Table class="collector-table" highlight-row stripe border :columns="columns" :data="datas"></Table>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'CollectorGroup',
  data () {
    return {
      columns: [
        { type: 'index', title: this.$t('device.group.index') },
        { title: this.$t('device.group.name'), key: 'name' },
        {
          title: this.$t('device.group.devices'),
          key: 'devices',
          render: (h, params) => {
            if (params.row.collectors === null) {
              return h('')
            }
            let cls = []
            for (var v of params.row.collectors) {
              let cl = this.collectors[v]
              if (cl !== undefined) {
                cls.push(cl)
              }
            }
            return h('span', cls.join())
          }
        },
        { title: this.$t('device.group.remark'), key: 'remark' },
        {
          title: this.$t('device.group.operating'),
          key: 'action',
          render: (h, params) => {
            if (this.permissions === true) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, this.$t('device.group.edit')),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      if (confirm(this.$t('device.group.delete_message'))) {
                        this.remove(params.index)
                      }
                    }
                  }
                }, this.$t('device.group.delete'))
              ])
            } else {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: true
                  },
                  style: {
                    marginRight: '5px'
                  }
                }, this.$t('device.group.edit')),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    disabled: true
                  }
                }, this.$t('device.group.delete'))
              ])
            }
          }
        }
      ],
      datas: [],
      collectors: {},
      permissions: false
    }
  },
  methods: {
    edit (index) {
      let id = index === -1 ? 0 : this.datas[index].id
      this.$router.push({ name: 'CollectorGroupEdit', params: { id } })
    },
    remove (index) {
      this.$api.collectorGroup.delete(this.datas[index].id).then(() => {
        this.datas.splice(index, 1)
      })
    }
  },
  mounted () {
    Api.collector.list().then(res => {
      let cls = {}
      for (var cl of res.collectors) {
        cls[cl.id] = cl.name
      }
      this.collectors = cls
    })
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'device' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    Api.collectorGroup.list().then(res => {
      next(vm => { vm.datas = res.collectorGroups })
    })
  }
}
</script>
<style scoped>
  .collector-page {
    padding: 10px;
  }

  .collector-table {
    margin-top: 20px;
  }
</style>





// WEBPACK FOOTER //
// List.vue?a75d53dc